import axios from "axios";
import Cookies from "js-cookie";

let isInStage =
  window.location.href.includes("stage") ||
  window.location.href.includes("192.");
let isInLocal = window.location.href.includes("localhost");
let url;
if (isInStage || isInLocal) url = "https://stock-stage.chuen.com.tw";
else url = "https://stock.chuen.com.tw";
const stockAPI = axios.create({
  baseURL: url,
  headers: { "Content-Type": "application/json" }
});

stockAPI.interceptors.request.use(function(config) {
  const token = Cookies.get("chuenStock");
  if (token) config.headers.common["Authorization"] = `Bearer ${token}`;
  return config;
});

stockAPI.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    if (
      error.response.status === 403 &&
      error.response.data.message === "Account was blacked."
    ) {
      const showMessage =
        "你已暫時被例入黑名單，若有問題請洽 goldwaylin@gmail.com";
      alert(showMessage);
    } else if (
      error.response.status === 401 &&
      error.response.data.message === "The Token was invalid."
    ) {
      const showMessage = "開通錯誤，請從最新一封帳號開通信點擊連結到此頁";
      alert(showMessage);
    }
    return Promise.reject(error.response);
  }
);

export default {
  async GET(url, params) {
    const res = await stockAPI.get(url, { params });
    return res;
  },
  async POST(url, data) {
    const res = await stockAPI.post(url, data);
    return res;
  },
  async PUT(url, data) {
    const res = await stockAPI.put(url, data);
    return res;
  },
  async DELETE(url, data) {
    const res = await stockAPI.delete(url, { data });
    return res;
  },
  stockAPI
};
